module.exports = __webpack_public_path__ + "static/media/portfoliobanner-extra-img-left.d29c34c4.png";